<template>
  <div>
    <div class="card mb-4" v-for="(item, index) in purchase.data" :key="index">
        <div class="card-body row">
            <div class="col-md-4">
                <img :src="item.account.thumbnail" :alt="`Account ${item.package.name} #item.game_account_id`">
            </div>
            <div class="col-md-4">
                <table class="table table-borderless">
                    <tr>
                        <td>Thời gian</td>
                        <td class="text-right">{{ item.format_created_at }}</td>
                    </tr>
                    <tr>
                        <td>ID tài khoản</td>
                        <td class="text-right">#{{ item.game_account_id }}</td>
                    </tr>
                    <tr>
                        <td>Giá tài khoản</td>
                        <td class="text-right">{{ Helper.formatMoney(item.account.price) }}</td>
                    </tr>
                    <tr>
                        <td>Số tiền đặt cọc</td>
                        <td class="text-right">{{ Helper.formatMoney(item.first_price) }}</td>
                    </tr>
                    <tr>
                        <td>Số tiền thanh toán đợt 2</td>
                        <td class="text-right"><b class="text-warning">{{ Helper.formatMoney(item.last_price) }}</b></td>
                    </tr>
                    <tr>
                        <td>Số tiền nhận lại nếu huỷ đặt cọc</td>
                        <td class="text-right"><b class="text-danger">{{ Helper.formatMoney(item.price_cancel) }}</b></td>
                    </tr>
                </table>
            </div>
            <div class="col-md-4 text-center">
                <p v-html="item.status_html"></p>
            </div>
        </div>

        <div class="card-footer row" v-if="item.status == 'pending'">
            <div class="col-md-6">
                <p class="my-auto">Vui lòng thanh toán <b class="text-warning">{{ Helper.formatMoney(item.last_price) }}</b> trước ngày <b>{{ item.format_deadline }}</b> để nhận tài khoản bạn nhé!</p>
            </div>
            <div class="col-md-6 text-right">
                <p>Đã thanh toán <b class="text-success">{{ Helper.formatMoney(item.first_price) }}</b></p>
                <button @click="cancelAccount(item)" :disabled="btn_cancel_disabled" class="btn btn-danger btn-sm">Huỷ cọc</button>
                <button @click="buyAccount(item)" :disabled="btn_payment_disabled" class="btn btn-success btn-sm">Thanh toán ngay <b>{{ Helper.formatMoney(item.last_price) }}</b></button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
      purchase: {
        Type: Object,
        default() {
          return {};
        }
      },
      website: {
        Type: Object,
        data() {
          return {}
        }
      }
  },

  data() {
    return {
        btn_payment_disabled: false,
        btn_cancel_disabled: false,
        date: new Date(),
    };
  },

  methods: {
    async cancelAccount(item) {
      this.btn_cancel_disabled = true
      try {
        const uri = this.route('fe_deposit_cancel', {domain: this.website.domain});
        const response = await this.Request.post(uri, { id: item.id });

        if (response.data.status == false) {
            this.$swal.fire({
              icon: 'error',
              title: 'Lỗi',
              html: response.data.message,
            }
          );
        } else {
          await this.$swal.fire({
              icon: 'success',
              title: 'Thành Công',
              html: response.data.message,
            }
          );

          window.location.reload();
        }

        this.btn_cancel_disabled = false;
      } catch (e) {
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: this._.isEmpty(errorMessages) ? e.response.data.error : errorMessages[0],
        });

        this.btn_cancel_disabled = false;
      }
    },

    async buyAccount(item) {
      this.btn_payment_disabled = true
      try {
        const uri = this.route('fe_deposit_payment', {domain: this.website.domain});
        const response = await this.Request.post(uri, { id: item.id });

        if (response.data.status == false) {
            this.$swal.fire({
              icon: 'error',
              title: 'Lỗi',
              html: response.data.message,
            }
          );
        } else {
          await this.$swal.fire({
              icon: 'success',
              title: 'Thành Công',
              html: response.data.message,
            }
          );

          window.location.href = this.route('lsmua', {domain: this.website.domain});
        }

        this.btn_payment_disabled = false;
      } catch (e) {
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: this._.isEmpty(errorMessages) ? e.response.data.error : errorMessages[0],
        });

        this.btn_payment_disabled = false;
      }
    },
  },
}
</script>

<style>

</style>
